export default __webpack_public_path__ + "static/freshms-teaser2-mobilex2-bd81fb850db70f32b3800873442a9a93.png";